import '@angular/compiler';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PageWikiTaxonomyDesignComponent } from './page.wiki.taxonomy.design/page.wiki.taxonomy.design.component';
import { PageDocsDraftComponent } from './page.docs.draft/page.docs.draft.component';
import { PageBenchmarksLlmDetailComponent } from './page.benchmarks.llm.detail/page.benchmarks.llm.detail.component';
import { PageMainTopicComponent } from './page.main.topic/page.main.topic.component';
import { PageMainComponent } from './page.main/page.main.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageReportComponent } from './page.report/page.report.component';
import { PageFrameworksCavemanComponent } from './page.frameworks.caveman/page.frameworks.caveman.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageCodexSkillsComponent } from './page.codex.skills/page.codex.skills.component';
import { PageLlmTaxonomyComponent } from './page.llm.taxonomy/page.llm.taxonomy.component';
import { PageCodexGoalComponent } from './page.codex.goal/page.codex.goal.component';
import { PageSearchComponent } from './page.search/page.search.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageBenchmarksLlmComponent } from './page.benchmarks.llm/page.benchmarks.llm.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';

const INDEX_PAGE = "main";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "wiki-taxonomy-design",
                component: PageWikiTaxonomyDesignComponent,
                "app_id": "page.wiki.taxonomy.design"
            },
            {
                "path": "docs/draft/:draftId",
                component: PageDocsDraftComponent,
                "app_id": "page.docs.draft"
            },
            {
                "path": "benchmarks/llm-agent/:slug",
                component: PageBenchmarksLlmDetailComponent,
                "app_id": "page.benchmarks.llm.detail"
            },
            {
                "path": "main/:section/:subsection?",
                component: PageMainTopicComponent,
                "app_id": "page.main.topic"
            },
            {
                "path": "main",
                component: PageMainComponent,
                "app_id": "page.main"
            },
            {
                "path": "report",
                component: PageReportComponent,
                "app_id": "page.report"
            },
            {
                "path": "frameworks/caveman",
                component: PageFrameworksCavemanComponent,
                "app_id": "page.frameworks.caveman"
            },
            {
                "path": "members",
                component: PageMembersComponent,
                "app_id": "page.members"
            },
            {
                "path": "codex-skills",
                component: PageCodexSkillsComponent,
                "app_id": "page.codex.skills"
            },
            {
                "path": "llm-taxonomy",
                component: PageLlmTaxonomyComponent,
                "app_id": "page.llm.taxonomy"
            },
            {
                "path": "codex-skills/goal",
                component: PageCodexGoalComponent,
                "app_id": "page.codex.goal"
            },
            {
                "path": "search",
                component: PageSearchComponent,
                "app_id": "page.search"
            },
            {
                "path": "benchmarks/llm-agent",
                component: PageBenchmarksLlmComponent,
                "app_id": "page.benchmarks.llm"
            },
            {
                "path": "dashboard",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            },
            {
                "path": "posts",
                component: PagePostsComponent,
                "app_id": "page.posts"
            },
            {
                "path": "posts/:id/:tab?",
                component: PagePostsItemComponent,
                "app_id": "page.posts.item"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }
